import Translation from '../../../v2/lang/Translation';
import store from '../../../v2/store/store';

export default (attributes, paymentOption) => {
  if (paymentOption.type === 'STORED_CREDIT_CARD') {
    return null;
  }
  
  let iconsArray = [];
  
  if (attributes.icons) {
    iconsArray = Array.isArray(attributes.icons)
      ? attributes.icons
      : [attributes.icons];
  }
  
  let title;
  if (typeof attributes.title === 'function') {
    if (attributes.alwaysShowTitle) {
      title = Translation.getText(attributes.title(store.getState()));
    }
  } else if (attributes.alwaysShowTitle
    || store.getState().start.settings.show_payment_option_titles) {
    title = Translation.getText(attributes.title);
  }
  
  // Set up help text
  const helpText = typeof attributes.helpText === 'string'
    ? Translation.getText(attributes.helpText)
    : '';
  
  const translatedPaymentName = Translation.getText(attributes.paymentName)
    || attributes.shortName;
  
  const iconTitle = paymentOption.type !== 'NEW_CREDIT_CARD'
    ? Translation.getText(attributes.iconTitle, translatedPaymentName)
    : null;
  
  return {
    customTitleIcon: attributes.customTitleIcon,
    iconsArray,
    title,
    helpText,
    iconTitle,
    forId: attributes.inputId,
    imgId: attributes.imgId,
    useFullSizeIconsInArray: attributes.useFullSizeIconsInArray,
    useInitialHeight: attributes.useInitialHeight,
  };
};
